export const constant = {
  userName: "",
  clientIdGoogle: "103388376992-2gigmnbjla91p3ecgmje2276rcj6im37.apps.googleusercontent.com",
  appIdFb: "488806647206287",
  appIdFbCRM: "1446709515630218",
  ruleset_regional_backtrack: "A",
  ruleset_regional_non_backtrack: "B",
  ruleset_regional_non_thai_intercontinental: "C",
  "ruleset_non-regional_international": "D",
  ruleset_domestic_international: "E",
  ruleset_intercontinental_non_thai: "F",
  ruleset_origin_bkk: "G",
  contact_mail: "digital-accounting@thaiairways.com",
  review_info_silver: "Silver",
  review_info_gold: "Gold",
  review_info_platinum: "Platinum",
  review_info_member: "Silk",
  review_info_nominee: "Nominee",
  appScheme: "https://app.thaiairways.com/utils/qrdownload",
  baggage_info: "*Additional baggage weight applies on THAI operated flights. When traveling with other Star Alliance airlines,additional baggage weight for Platinum members is equivalent to the Gold Star Alliance benefit (20 kg).",
  baggage_text1: "1 additional piece is permitted for Platinum and Gold members when the piece concept applies.",
  baggage_text2: `Some airlines do not offer this benefit on individual flights but only on connecting Star Alliance flights. Within Europe on "Light" fares offered by Lufthansa, Austrian & SWISS, "Check&Go" fares offered by Brussels Airlines and “Go light” fares offered by SAS as well as on “Seat” fares offered by Air New Zealand, the extra baggage allowance is not offered.`,
  baggage_text: "If your journey involves multiple airline partners, please be aware that baggage rules may vary. In case of code-share flights that include a point in the United States/US Territories, the carrier performing as the marketing carrier determines the baggage rule. In some cases, the baggage rules that apply for your journey may be those of our partner airlines, please contact your travel agent or our ticketing/reservation agent for further advice.",
  bookingClass: [{
    id: "1",
    listName: "label_economy",
    value: "I"
  }, {
    id: "2",
    listName: "label_economy_plus",
    value: "X"
  }, {
    id: "3",
    listName: "label_address_type_business",
    value: "O"
  }, {
    id: "4",
    listName: "label_first",
    value: "O"
  }],
  SubCategory: [{
    id: "1",
    listName: "label_baggage",
    value: "Baggage"
  }, {
    id: "9",
    listName: "label_staff",
    value: "Staff"
  }, {
    id: "2",
    listName: "label_flight_irregularity",
    value: "Flight irregularity"
  }, {
    id: "3",
    listName: "label_ground_service",
    value: "Ground service"
  }, {
    id: "4",
    listName: "label_inflight_service",
    value: "Inflight service"
  }, {
    id: "5",
    listName: "label_Refund",
    value: "Refund / waiver process service"
  }, {
    id: "6",
    listName: "label_online_booking",
    value: "Online Booking"
  }, {
    id: "7",
    listName: "label_request_for_receipt",
    value: "Request for receipt"
  }, {
    id: "8",
    listName: "label_other",
    value: "Other"
  }],
  starBookingClass: [{
    id: "1",
    listName: "label_economy",
    value: "X"
  }, {
    id: "2",
    listName: "label_economy_plus",
    value: "E"
  }, {
    id: "3",
    listName: "label_business",
    value: "I"
  }, {
    id: "4",
    listName: "label_first_class",
    value: "O"
  }],
  starBookingUpgradeClass: [{
    id: "1",
    listName: "label_economy",
    value: "Y",
    upgradeClass: "I"
  }, {
    id: "3",
    listName: "label_business",
    value: "C",
    upgradeClass: "O"
  }],
  feedbackReaction: [{
    id: 1,
    text: "Compliments",
    value: "Compliments",
    icon: "compliments"
  }, {
    id: 2,
    text: "Complaints",
    value: "Complaints",
    icon: "complaints"
  }, {
    id: 3,
    text: "Suggestions",
    value: "Suggestions",
    icon: "suggestions"
  }],
  feedback: [{
    id: 1,
    label: "Your experience with Thai Airways",
    sub_label: "Let us know how we did, or how we could’ve done better.",
    value: "true"
  }, {
    id: 2,
    label: "Royal Orchid Plus Feedback",
    sub_label: "Share suggestions on how we can improve our Royal Orchid Plus programme.",
    value: "false"
  }],
  feedbackSpecificFlight: [{
    id: 1,
    label: "Yes",
    sub_label: "My feedback is specific to a particular flight or booking.",
    value: "true"
  }, {
    id: 2,
    label: "No",
    sub_label: "It is just a generic feedback about Thai Airways services.",
    value: "false"
  }],
  tierData: [{
    tier: "silk",
    value: "Silk"
  }, {
    tier: "silver",
    value: "Silver"
  }, {
    tier: "gold",
    value: "Gold"
  }, {
    tier: "platinum",
    value: "Platinum"
  }],
  redemptionSuccesNotETicketEmail: "contact@thaiairways.com",
  redemptionSuccessContactDetails: "+66 2 356 1111",
  frequentFlyerProgram: [{
    id: "0",
    listName: "None",
    value: undefined
  }, {
    id: "1",
    listName: "Royal Orchid Plus – Basic",
    value: "basic"
  }, {
    id: "2",
    listName: "Royal Orchid Plus – Silver",
    value: "silver"
  }, {
    id: "3",
    listName: "Royal Orchid Plus – Gold",
    value: "gold"
  }, {
    id: "4",
    listName: "Royal Orchid Plus – Platinum",
    value: "platinum"
  }, {
    id: "5",
    listName: "Star Alliance Member",
    value: "star"
  }],
  flightDisruptionCertificateType: [{
    id: "1",
    listName: "Flight Delay",
    value: "Flight Delay"
  }, {
    id: "2",
    listName: "Flight Cancellation",
    value: "Flight Cancel"
  }],
  starAirAwardsPage: "https://www.thaiairways.com/en_TH/rop/Redeeming/Redeeming_Award-Air_Awards_onTHAI.page",
  currency_Thai: "THB",
  currency_Us: "USD",
  thai_Airways: "Thai Airways",
  tg: "tg",
  airbus: "airbus",
  osciDataLayer: {
    page_home_name: "home page",
    page_home_id: "homePage",
    page_home_category: "Home",
    page_subscribe_name: "Subscribe Newsletter",
    page_subscribe_id: "subscribeNewsletter",
    page_subscribe_category: "Subscription",
    page_unsubscribe_name: "Unsubscribe Newsletter",
    page_unsubscribe_id: "unsubscribeNewsletter",
    page_unsubscribe_category: "Unsubscription",
    page_book_flight_category: "Search Flight",
    page_flight_status_category: "Flight Status",
    page_check_in_category: "CheckIn",
    page_manage_booking_category: "Manage Booking",
    page_flight_route_name: "Flight Route",
    page_flight_number_name: "Flight Number",
    page_rop_enrol: "ROP Enrol",
    page_rop_enrol_id: "ropEnrol",
    ropenroll_eventName: "ropEnrol",
    ropenroll_event: "ropEnrol",
    page_rop_enrol_category: "ROP Enrol",
    page_rop_enrol_success_name: "ROP Enrol Success",
    page_rop_enrol_success_id: "ropEnrolSuccess",
    ropenrollsuccess_event: "ropEnrolSuccess",
    ropenrollsuccess_eventName: "ropEnrolSuccess",
    page_rop_enrol__success_category: "ROP Enrol Success",
    page_miles_management: "miles management",
    page_gift_miles_name: "gift miles",
    page_gift_miles_id: "giftMiles",
    page_gift_miles_success_name: "gift miles success",
    page_gift_miles_success_id: "giftMilesSuccess",
    page_gift_miles_error_name: "gift miles error",
    page_gift_miles_error_id: "giftMilesError",
    page_transfer_miles_name: "transfer miles",
    page_transfer_miles_id: "transferMiles",
    page_transfer_miles_success_name: "transfer miles success",
    page_transfer_miles_success_id: "transferMilesSuccess",
    page_transfer_miles_error_name: "transfer miles error",
    page_transfer_miles_error_id: "transferMilesError",
    page_mileage_purchase_name: "mileage purchase",
    page_mileage_purchase_id: "mileagePurchase",
    page_mileage_purchase_success_name: "mileage purchase success",
    page_mileage_purchase_success_id: "mileagePurchaseSuccess",
    page_mileage_purchase_error_name: "mileage purchase error",
    page_mileage_purchase_error_id: "mileagePurchaseError",
    page_extend_expiry_miles_name: "extend expiry miles",
    page_extend_expiry_miles_id: "extendExpiryMiles",
    page_extend_expiry_miles_success_name: "extend expiry miles success",
    page_extend_expiry_miles_success_id: "extendExpiryMilesSuccess",
    page_extend_expiry_miles_error_name: "extend expiry miles error",
    page_extend_expiry_miles_error_id: "extendExpiryMilesError",
    page_enrol_category: "enrol",
    page_mythai_enrol_name: "Mythai enrol",
    page_mythai_enrol_id: "mythaiEnrol",
    page_redemption_book_flight_category: "Redemption Book Flight",
    page_redemption_select_flight_category: "Redemption Select Flight",
    page_redemption_review_passenger_category: "Redemption Review Passenger",
    page_redemption_review_information_category: "Redemption Review Information",
    page_redemption_confirmation_summary_category: "Redemption Payment Summary",
    pageEvent: "pageLoad",
    bookflightEvent: "searchFlight",
    bookflight_eventName: "searchFlight",
    widgetBookFlightEvent: "bookFlightPage",
    bookFlightMultiCityEvent: "searchFlightMultiCity",
    manageBookEvent: "manageBooking",
    discoverClickEvent: "discover_click",
    bookNowEvent: "book_now_click",
    otpGenerateSuccessEvent: "otp_generate_success",
    logInInitiationEvent: "log_in_initiation",
    logInErrorEvent: "log_in_error",
    passwordResetEvent: "password_reset_click",
    logInResendOTPEvent: "log_in_resend_otp_click",
    signOutClickEvent: "sign_out_click",
    checkInEvent: "checkIn",
    eventName: "checkIn",
    widgetCheckIn: "checkinPage",
    flightStatusEvent: "flightStatus",
    flightStatusEvent_eventName: "flightStatus",
    redemptionFlightEvent: "redemptionSearchFlight",
    redemptionBookFlightMultiCityEvent: "redemptionSearchFlightMultiCity",
    redemptionFlightSelectionEvent: "redemptionFlightSelectDetails",
    redemptionPassengerSelectionEvent: "redemptionPassengerDetails",
    redemptionReviewInformationEvent: "redemptionReview",
    redemptionConfirmationEvent: "redemptionConfirmation",
    redemptionErrorEvent: "redemptionError",
    purchaseMilesEvent: "purchaseMiles",
    purchaseMilesSuccessEvent: "purchaseMilesSuccess",
    purchaseMilesErrorEvent: "purchaseMilesError",
    redemptionFlightSelectionEvent_name: "redemption flight select details",
    redemptionPassengerSelectionEvent_name: "redemption passenger details",
    redemptionReviewInformationEvent_name: "redemption review",
    redemptionConfirmationEvent_name: "redemption confirmation",
    redemptionError_name: "redemption error",
    widgetBookFlight_name: "Book Flight",
    widgetBookFlightMultiCity_name: "Book Flight Multi City",
    redemptionFlightSelectionEvent_id: "redemptionFlightSelectDetails",
    redemptionPassengerSelectionEvent_id: "redemptionPassengerDetails",
    redemptionReviewInformationEvent_id: "redemptionReview",
    redemptionConfirmationEvent_id: "redemptionConfirmation",
    redemptionError_id: "redemptionError",
    redemptionFlightSelectionEvent_category: "Redemption Flight Select Details",
    redemptionPassengerSelectionEvent_category: "Redemption Passenger Select Details",
    redemptionReviewInformationEvent_category: "Redemption Review",
    redemptionConfirmationEvent_category: "Redemption Confirmation",
    redemptionError_category: "Redemption Error",
    page_mythai_signin_name: "mythai SignIn",
    page_login_category: "OSCI",
    page_mythai_signin_id: "mythaiSignIn",
    page_mythaicrmsignin_event_name: "mythaicrmSignin",
    page_subscribe_error_name: "Subscribe Newsletter Error",
    page_subscribe_error_id: "subscribeNewsletterError",
    page_unsubscribe_success_name: "Unsubscribe Newsletter Success",
    page_unsubscribe_sucess_id: "unsubscribeNewsletterSuccess",
    page_newsletter_name: "newsletter",
    redemption_error_message: "Redemption Failure",
    popularFaresBookNow: "popularFaresBookNow",
    // page_ropsignin_event: "Rop Signin",
    // page_ropsignin_id: "ropSignin",
    // page_rop_ropsignin_category: "Rop Signin",
    page_mythairopropsignin_event_name: "mythairopSignIn",
    page_newsletterSubscribe_event_name: "newsletterSubscribe",
    page_newsletterUnsubscribe_event_name: "newsletterUnsubscribe",
    page_giftMiles_event_name: "giftMiles",
    page_giftMilesSuccess_event_name: "giftMilesSuccess",
    page_giftMilesError_event_name: "giftMilesError",
    page_purchaseMiles_event_name: "purchaseMiles",
    page_purchaseMilesSuccess_event_name: "purchaseMilesSuccess",
    page_purchaseMilesError_event_name: "purchaseMilesError",
    page_transferMiles_event_name: "transferMiles",
    page_transferMilesSuccess_event_name: "transferMilesSuccess",
    page_transferMilesError_event_name: "transferMilesError",
    page_extendExpiryMiles_event_name: "extendExpiryMiles",
    page_extendExpiryMilesError_event_name: "extendExpiryMilesError",
    page_mythaiEnrol_event_name: "mythaiEnrol",
    page_mythaiEnrolSuccess_event_name: "mythaiEnrolSuccess",
    page_redemptionFlightEvent_event_name: "redemptionSearchFlight",
    page_redemptionBookFlightMultiCityEvent_event_name: "redemptionSearchFlightMultiCity",
    page_redemptionFlightSelection_event_name: "redemptionFlightSelectDetails",
    page_redemptionPassengerSelection_event_name: "redemptionPassengerDetails",
    page_redemptionReviewInformation_event_name: "redemptionReview",
    page_redemptionConfirmation_event_name: "redemptionConfirmation",
    page_redemptionError_event_name: "redemptionError",
    page_popularFaresBookNow_event_name: "popularFaresBookNow",
    page_extendExpiryMilesSuccess_event_name: "miles management",
    viewAnicileryEvent: "view_non_air_ancillary",
    selectAnicileryEvent: "select_non_air_ancillary",
    page_non_aciliery_category: "Non Aciliery",
    page_non_anciliery_id: "view_non_air_ancillary"
  },
  dapiDataLayer: {
    pageEvent: "pageLoad",
    page_select_passenger_name: "select passengers screen",
    page_select_passenger_id: "selectPassengerCheckIn",
    page_select_passenger_category: "CheckIn",
    page_select_passenger_event_name: "checkIn_passenger_selection",
    page_select_passenger_event: "checkIn_passenger_selection",
    // Add Passenger
    page_add_passenger_name: "select passengers screen",
    page_add_passenger_id: "addPassenger",
    page_add_passenger_category: "CheckIn",
    page_add_passenger_event: "add_passenger_checkIn",
    page_add_passenger_event_name: "add_passenger_checkIn",
    // page_extra_services_name:"Extra Services",
    // page_extra_services_id:"extraServices",
    // page_extra_services_category:"Extra Services",
    // page_extra_services_event:"extra_services_submission",
    // Edit Passenger
    page_edit_passenger_category: "CheckIn",
    page_edit_passenger_event_name: "edit_checkIn_passenger",
    page_edit_passenger_event: "edit_checkIn_passenger",
    page_edit_passenger_name: "complete checkin screen",
    page_edit_passenger_id: "editPassenger",
    // Modify Seat
    page_modify_seat_category: "CheckIn",
    page_modify_event_name: "modify_checkIn_seat",
    page_modify_seat_event: "modify_checkIn_seat",
    page_modify_seat_name: "modify checkin screen",
    page_modify_seat_id: "modifySeat",
    // Seat Selection
    page_extra_services_seat_selection_name: "modify checkin screen",
    page_extra_services_seat_selection: "selectSeat",
    page_extra_services_seat_selection_category: "CheckIn",
    page_extra_services_seat_selection_event_name: "checkIn_seat_selection",
    page_extra_services_seat_selection_event: "checkIn_seat_selection",
    // Initiate Cancel Checkin
    page_cancel_checkin_name: "complete checkin screen",
    page_cancel_checkin_event_name: "initiate_checkIn_cancel",
    page_cancel_checkin_id: "cancelCheckin",
    page_cancel_checkin_category: "CheckIn",
    page_cancel_checkin_event: "initiate_checkIn_cancel",
    // Cancel Checkin
    page_extra_services_cancel_checkin_name: "cancel checkin screen",
    page_extra_services_cancel_checkin_event_name: "cancel_checkIn",
    page_extra_services_cancel_checkin_id: "cancelCheckin",
    page_extra_services_cancel_checkin_category: "CheckIn",
    page_extra_services_cancel_checkin_event: "Checkin_Cancel",
    // Complete Checkin
    page_complete_checkin_name: "complete checkin screen",
    page_complete_checkin_id: "completeCheckin",
    page_complete_checkin_event: "complete checkin screen",
    page_complete_checkin_category: "CheckIn",
    page_complete_checkin_event_name: "checkIn_success",
    //Exit Checkin
    page_exit_checkin_id: "exitCheckin",
    page_exit_checkin_event: "exit_checkIn_flow",
    page_exit_checkin_category: "CheckIn",
    page_exit_checkin_event_name: "exit_checkIn_flow",
    // Get Boarding Pass
    page_boarding_pass_checkin_id: "complete checkin",
    page_boarding_pass_checkin_event: "get_boarding_pass",
    page_boarding_pass_checkin_event_name: "get_boarding_pass",
    page_boarding_pass_checkin_category: "CheckIn",
    page_boarding_pass_checkin_name: "complete checkin screen",
    // Error Case
    page_error_checkin_id: "All screens",
    page_error_checkin_event: "error_event",
    page_error_event_name: "error_event",
    page_error_checkin_category: "CheckIn",
    page_error_checkin_name: "All screens",
    // Boarding Pass Actions
    page_boarding_pass_id: "complete checkin",
    page_boarding_pass_event: "share_eboarding_pass",
    page_boarding_pass_event_name: "share_eboarding_pass",
    page_boarding_pass_category: "CheckIn",
    page_boarding_pass_name: "boarding pass screen",
    // Add Boarding Pass Event
    page_add_boarding_pass_id: "complete checkin",
    page_add_boarding_pass_event: "add_boardingpass_to_wallet",
    page_add_boarding_pass_event_name: "add_boardingpass_to_wallet",
    page_add_boarding_pass_category: "CheckIn",
    page_add_boarding_pass_name: "boarding pass screen",
    // Add Boarding Pass Event
    page_join_now_id: "complete checkin",
    page_join_now_event: "join_now_checkedIn",
    page_join_now_event_name: "join_now_checkedIn",
    // FFP Update
    page_ffp_update_event: "ffp_checkin_update",
    page_ffp_update_event_name: "ffp_checkin_update",
    //FFP Submit
    page_ffp_submit_event: "ffp_otp_popup_confirm",
    page_ffp_submit_event_name: "ffp_otp_popup_confirm",
    // Screen Names
    page_dangerous_goods_name: "dangerous goods screen",
    page_exit_row_questionnaire: "exit row screen",
    page_samesung_wallet: "samsung wallet screen",
    page_cancelled_checkin: "canceled checkin screen",
    page_cancel_fail: "canceled checkin failed screen",
    page_boarding_pass: "boarding pass screen",
    page_passenger_details: "passenger details screen",
    // View Insurance
    page_view_insurance_category: "CheckIn",
    page_view_insurance_event: "view_insurance",
    page_view_insurance_event_name: "view_insurance",
    // Insurance Links
    page_link_select_insurance_id: "travel insurance",
    page_link_select_insurance_event: "click_insurance_info",
    page_link_select_insurance_event_name: "click_insurance_info",
    page_insurance_category: "CheckIn",
    page_insurance_name: "insurance select screen",
    // Privacy Policy
    page_privacy_policy_event: "select_privacy_policy",
    page_privacy_policy_event_name: "select_privacy_policy",
    // Confirm Add Insurance
    page_confirm_add_insurance_event: "confirm_add_insurance",
    page_confirm_add_insurance_event_name: "confirm_add_insurance",
    // Discard Insurance
    page_discard_insurance_event: "discard_add_insurance",
    page_discard_insurance_event_name: "discard_add_insurance",
    // Error Page
    page_error_payment_event: "error_page_click",
    page_error_payment_event_name: "error_page_click",
    // Initiate Ancillary
    page_initiate_payment_event: "initiate_ancillary_payment",
    page_initaite_payment_event_name: "initiate_ancillary_payment",
    // Payment Failure Screen
    page_payment_failure_id: "payment failure",
    page_payment_failure_event: "error_event",
    page_payment_failure_event_name: "error_event",
    page_payment_failure_category: "CheckIn",
    page_payment_failure_name: "payment failure screen",
    // Payment Error
    page_payment_error_name: "payment error screen",
    // Process Ancillary
    page_payment_process_id: "payment progress",
    page_payment_process_event: "process_ancillary_payment",
    page_payment_process_event_name: "process_ancillary_payment",
    page_payment_process_category: "CheckIn",
    page_payment_process_name: "payment progress screen",
    // Purchase Ancillary
    page_purchase_confirmation_event: "purchase_ancillary_payment",
    page_purchase_confirmation_event_name: "purchase_ancillary_payment",
    page_insurance_purchase_confiramtion: "Travel Insurance",
    ancillary_provider_name: "Allianz",
    ancillary_insurance_name: "Insurance - ",
    one_way_trip: "One Way",
    round_trip: "Round Trip",
    multicity_trip: "MultiCity",
    insurance_purchase_one_way: "OW",
    insurance_purchase_round_trip: "RT",
    insurance_purchase_flow: "CheckIn Flow",
    insurance_chargeable: "insurance | chargeable",
    insurance_cateogry: "insurance",
    insurance_purchase: "purchase",
    insurance_content_grp: "DAPI checkIn flow",
    insurance_item_brand: "flight",
    // Travel Ready
    page_passport_verified: "checkIn_passport_verified",
    page_visa_verified: "checkIn_visa_verified",
    page_resident_card_verified: "checkIn_resident_card_verified"
  },
  supportedImagesLoungeAmenities: ["food", "snacks", "accessibility", "tv", "wifi", "beverages", "showers", "charger", "flight-information", "kids", "childrens-area", "utilities", "restroom", "magazines", "workstation", "others"],
  listOfClassLounge: [{
    id: 1,
    listName: "All",
    label: "All",
    value: "All"
  }, {
    id: 2,
    listName: "Domestic",
    label: "Domestic",
    value: "Domestic"
  }, {
    id: 3,
    listName: "International",
    label: "International",
    value: "International"
  }],
  classLoungeFinder: [{
    id: 1,
    listName: "First",
    label: "First",
    value: "First"
  }, {
    id: 2,
    listName: "Business",
    label: "Business",
    value: "Business"
  }, {
    id: 3,
    listName: "Premium Economy & Economy",
    label: "Premium Economy & Economy",
    value: "Premium Economy & Economy"
  }],
  paidMemberShipCard: [{
    id: 1,
    listName: "United Club",
    label: "United Club",
    value: "United Club"
  }, {
    id: 2,
    listName: "AC Maple Leaf Club - Worldwide",
    label: "AC Maple Leaf Club - Worldwide",
    value: "AC Maple Leaf Club - Worldwide"
  }],
  flightScheduleSortType: [{
    label: "Recommended",
    value: "TN"
  }, {
    label: "Travel Duration",
    value: "TE"
  }, {
    label: "Arrival Time",
    value: "TA"
  }, {
    label: "Departure Time",
    value: "TD"
  }],
  mealStatusTabs: [{
    value: "Meals 1",
    label: "Meal 1"
  }, {
    value: "Meals 2",
    label: "Meal 2"
  }],
  bookingRegex: /^(?=.{6}$)(?![0-9]{6})[a-zA-Z0-9]{6}$/,
  nonEngMarketLists: ["tr", "de", "fr", "it"],
  supportedMarket: ["th", "au", "la", "nz", "lk", "kh", "bd", "np", "mm", "my", "ca", "id", "ph", "sg", "us", "be", "pk", "dk", "in", "gb", "ch", "no", "se", "tw", "kr", "jp", "it", "fr", "de", "tr", "es", "vn", "cn", "hk", "nl"],
  bangkok_airways: "Bangkok Airways",
  routeTranslationLan: ["it", "de", "fr"],
  dapiPaths: ["/booking/", "/managebooking/"],
  one_way: "One Way",
  max_cookie_size: 4000,
  insuranceFailedText: "insurancecommitfailed",
  insuranceSkFailed: "insuranceskfailed",
  outbound_thai_contact: "+66 2 356 1111",
  inbound_thai_contact: "+44 1603 804371"
};
//TODO: to change to TG provided client id and facebook app id. This is developer created for testing
export const CPHLoungeLink = "https://www.cph.dk/en/practical/workspaces-and-lounges/aspire-lounge";
export const mmbOfficeIds = ["BKKTG08BB", "BKKTG08CC", "BKKTG08SB", "BKKTG08PT"];
export const globalLookupCodes = {
  X: "Economy",
  E: "Premium Economy",
  I: "Royal Silk Business",
  O: "First"
};
export const selectedCategoryKeyChange = {
  "Correct Name Spelling": "Correct name spelling",
  "Request to Purchase Extra Seat": "Request to purchase extra seat",
  "Travel with Assistance Pets": "Travel with assistance pets",
  "Travel with Music Instrument": "Travel with music instrument",
  "Travel with Special Baggage": "Travel with special baggage",
  "Travel with Sport Equipment": "Travel with sport equipment",
  "Request for Baby Bassinet": "Request for baby bassinet",
  "Seating Sick / Stretcher Passenger": "Seating sick / Stretcher passenger",
  "Unaccompained Minor Passenger": "Unaccompained minor passenger",
  "Request for Portable Oxygen": "Request for portable oxygen",
  "Request for Purchase Oxygen": "Request for purchase oxygen"
};
export const restrictBookingHomeNavigation = ["/booking/extra-services", "/booking/seat-selection", "/booking/extra-services/excess-baggage", "/booking/meals-selection"];
export const allowDapiBookingShoppingCart = ["/booking/select-flight", "/booking/complete-booking"];
export const PROMO_CFF_CABIN_MAP = {
  ecoPremEcoCff: "PE",
  busFirstCff: "BF",
  ecoCff: "E",
  premEcoCff: "P",
  businessCff: "B",
  firstCff: "F",
  ecoTxtCff: "PE",
  firstClassTxtCff: "BF"
};
export const PROMO_CFF_LABEL_MAP = {
  ecoPremEcoCff: "Economy & Premium Economy",
  busFirstCff: "Business & First",
  ecoCff: "Economy",
  premEcoCff: "Premium Economy",
  businessCff: "Business",
  firstCff: "First",
  ecoTxtCff: "Economy & Premium Economy",
  firstClassTxtCff: "Business & First"
};
export const THAILAND_AIRPORT_CODES = ["CNX", "CEI", "HDY", "KKC", "USM", "KBV", "KOP", "NST", "NAW", "HKT", "UBP", "UTH", "BKK", "DMK", "LOE", "ROI", "TDX", "TST", "URT"];
export const CPHBusLoungeLink = "https://www.cph.dk/en/practical/workspaces-and-lounges/pearl-lounge";